import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { Courier } from "@/app/services/generated/courierService";
import { courierService } from "@/app/services/generated/courierService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasCouriersCache {
  couriers: CouriersCache;
}

// Singleton cache store
const couriersCacheStore = new EntityCacheStore<Courier>(
  EnumCacheEntityType.courier,
  async () => courierService.getAllCouriers()
);

// Ephemeral reader
export default class CouriersCache extends EntityWithGuidKeyCache<Courier> {
  constructor() {
    super(couriersCacheStore, (x) => x.id);
  }
}
